
import { toast } from 'sonner';
import i18n from '@/i18n';

export const showSuccessToast = (key: string, fallback?: string) => {
  const message = i18n.t(key) || fallback || key;
  console.log('Toast message:', message);
  toast.success(message);
};

export const showErrorToast = (key: string, fallback?: string) => {
  const message = i18n.t(key) || fallback || key;
  console.log('Toast error:', message);
  toast.error(message);
};
